var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1ModeAbsenceTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 5h2V2H59v3h2v3l3.39 3L61 14v3h-2v3h15v-3h-2v-3l-3.39-3L72 8V5zm-3 10.32V17h-5v-1.68l2.5-2.18 2.5 2.18zm0-8.64l-2.5 2.18L64 6.68V5h5v1.68zM45.5 27.74L62 41.17v21.75H29V56c.166.01.334.01.5 0 2.31 0 4.5-1.77 4.5-4V40a5.55 5.55 0 00-1.43-3.2l12.93-9.06zM19.88 34a3 3 0 114.55 0c-.097.125-.208.24-.33.34a3 3 0 01-4.2-.34h-.02zm9.62 19a1.5 1.5 0 01-1.5-1.5V41a1.08 1.08 0 00-1-1h-1v27.5a1.5 1.5 0 11-3 0V55h-2v12.5a1.5 1.5 0 11-3 0V40h-1a1 1 0 00-1 1v10.5a1.5 1.5 0 11-3 0V41a4 4 0 014-4h10a4 4 0 014 4v10.5a1.5 1.5 0 01-1.5 1.5z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Mode_absence_timer.a5cb8d39.svg";
export { SvgF1ModeAbsenceTimer as ReactComponent };